<style scoped>
    @import url("../../styles/rodape.scss");
</style>

<template>

    <div class="box_rodape">

        <!--<span class="el_parceiros_tit mt-16">Parceiros UPinC</span>

        <div class="el_parceiros_rodape mt-2 mb-4">
            <div class="parceiro" v-for="(el,i) in li" :key="i">
                <v-img cover class="img_parc" :style="{'border-radius':'90px'}" :src="el.img" />
            </div>
        </div>-->

        <div class="painel_co_fin mt-16">

            <div class="col_esq" @click="callInfoPRR()">

                <!--<span class="el_parceiros_tit mt-4">Apoios</span>-->

                <div class="el_parceiros_rodape mt-2 mb-4">
                    <div class="parceiro" v-for="(el2,i2) in li2" :key="i2">
                        <v-img cover class="img_parc" :style="{'border-radius':'90px'}" :src="el2.img" />
                    </div>
                </div>

                <div class="prr_info">
                    <v-img cover class="img_parc2" :src=prr_img_transp />
                </div>

            </div>

            <div class="col_esq">

                <!--<span class="el_parceiros_tit mt-4">Parceiros</span>-->
                <span class="el_parceiros_tit mt-4">Apoios</span>

                <div class="el_parceiros_rodape mt-2 mb-4">
                    <div class="parceiro" v-for="(el,i) in li" :key="i">
                        <v-img cover class="img_parc" :style="{'border-radius':'90px'}" :src="el.img" />
                    </div>
                </div>

            </div>

            <div class="col_dir">

                <div class="el_frase_rodape">
                    
                    <v-icon small :style="{'margin':'4px'}">
                        mdi-circle
                    </v-icon>

                    geral@upinc.pt
                    
                </div>
                
                <div class="el_frase_rodape">
                    
                    <v-icon small :style="{'margin':'4px'}">
                        mdi-circle
                    </v-icon>

                    <span>CIEC | Rua António Augusto Aguiar, Covilhã, Portugal</span>
                </div>

                <div class="el_frase_rodape">
                    
                    <v-icon small :style="{'margin':'4px'}">
                        mdi-circle
                    </v-icon>

                    <span>Rua dos Três Lagares, Fundão, Portugal</span>            
                </div>

            </div>

        </div>

        <span 
        class="el_end_rodape mt-16"
        >
            <v-icon small :style="{'margin':'4px'}">
                mdi-copyright
            </v-icon>

            2022-2026 Copyright UPinC Lda All right Reserved.
        </span>
            <!--<span class="inside_el_end_rodape"></span>-->
    
    </div>

</template>

<script>
export default {
    data() {
        return {
            li:[
                {'img':require('../../assets/uicanf1.png')},
                {'img':require('../../assets/incub1.png')},
                {'img':require('../../assets/ciecf3.png')},
                //{'img':require('../../assets/fac1.png')},
                {'img':require('../../assets/fabf2.png')}
            ],
            li2:[
                {'img':require('../../assets/iefp.jpg')},
                //{'img':require('../../assets/prrf1.png')},
                {'img':require('../../assets/ptcft0.png')}
            ],
            prr_img_transp:require('../../assets/prr/PRR_letra_cores-transp.png'),
        }
    },

    methods: {
        callInfoPRR() { window.open('https://recuperarportugal.gov.pt/'); },
    },
}
</script>
